export const openSourcingRequest = (term = '') => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('pttek:search-sourcing-request', {
      detail: {
        term: String(term || '').trim(),
        trigger: typeof document !== 'undefined' && document.activeElement?.focus ? document.activeElement : null
      }
    }));
  }
  return false;
};

if (typeof window !== 'undefined') {
  window.openSourcingRequest = openSourcingRequest;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-search-sourcing-open]');
    if (!trigger) return;
    event.preventDefault();
    openSourcingRequest(trigger.dataset.searchTerm || '');
  });
}
